import React from 'react'
import ReactDOM from 'react-dom/client'
import i18n from './i18n'
import { QueryClient, QueryClientProvider } from 'react-query'
import ErrorBoundary from '@/components/ErrrosBoundary'
import App from './App'
import { initAmplitude, initFacebookPixel, initSentry } from '@/services/analytics'
import '@/assets/scss/style.scss'

initFacebookPixel()
initAmplitude()
initSentry()

document.documentElement.lang = i18n.language

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </ErrorBoundary>,
)
